import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import {Table} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {GreyButton, RedButton} from "../common/ButtonsConstants";
import * as ApiUtils from "../../util/ApiUtils";
import Modal from "@material-ui/core/Modal";
import PhotoModal from "../common/PhotoModal";
import Paper from "@material-ui/core/Paper";
import SignaturePad from "react-signature-canvas";
import {KeyboardDatePicker} from "@material-ui/pickers";
import {withStyles} from "@material-ui/styles";
import moment from "moment";
import * as OperationalApiUtils from "../../util/OperationModuleApiUtils";
import PropTypes from "prop-types";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

class SwmsPartOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.state.id,
            companyName: props.state.companyName,
            address: props.state.address,
            abn: props.state.abn,
            companyContact: props.state.companyContact,
            position: props.state.position,
            phoneNumber: props.state.phoneNumber,
            project: props.state.project,
            jobAddress: props.state.jobAddress,
            jobDescription: props.state.jobDescription,
            printName: props.state.printName,
            signature: props.state.signature,
            date: props.state.date,
            uploadedPhoto: null,
            uploadedFileName: props.state.uploadedFileName,
            uploadedFileId: props.state.uploadedFileId,
        };
        this.onChange = this.onChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onModalOpen = this.onModalOpen.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
    }

    onChange(event) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }

    onDateChange(date, fieldName) {
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    onModalOpen() {
        this.setState({
            zoomedInModalShow: true,
        });
    }

    onModalClose() {
        this.setState({
            zoomedInModalShow: false,
        });
    }

    onImageUpload(event) {
        this.props.onChangeHandler();
        this.props.onImageUpload(event);
        /*
        let canvas = document.getElementById('imageCanvas');
        let parent = canvas.parentElement;
        let parentHeight = 150;
        let parentWidth = 300;
        if (parent) {
            parentHeight = parent.offsetHeight - 20;
            parentWidth = parent.offsetWidth;
        } else {
            console.log('no parent, defaulting');
        }

        let ctx = canvas.getContext('2d');
        let reader = new FileReader();
        reader.onload = function(event) {
            let img = new Image();
            img.onload = function() {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                const scale = img.width / img.height;
                if (scale > (parentWidth / parentHeight)) {
                    canvas.width = parentWidth;
                    canvas.height = (img.height/(img.width/300));
                    ctx.drawImage(img,0,0, parentWidth, (img.height/(img.width/300)));
                } else {
                    canvas.width = (img.width/(img.height/150));
                    canvas.height = parentHeight;
                    ctx.drawImage(img,0,0, (img.width/(img.height/150)), parentHeight);
                }
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
         */
    }

    onFileRemove() {
        OperationalApiUtils.deleteFile('/swms/deleteFile', this.state.id, this.state.uploadedFileId).then(
            () => this.setState({
                uploadedFileId: null,
                uploadedFileName: null,
            })
        );
    }

    onSignatureDrawn(fileName, sigPad) {
        this.props.onChangeHandler();
        this.props.onSignatureDrawn(fileName, sigPad);
    }

    render() {
        let {state} = this;

        return <Grid container spacing={0} style={{  }}>
            <Table>
                <TableRow>
                    <TableCell style={{ width : "30%", padding: "0px" }}>
                        <TextField
                            id="companyName"
                            name="companyName"
                            value={state.companyName}
                            label={ t('swms.companyName') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                    <TableCell style={{ width : "40%", padding: "0px" }}>
                        <TextField
                            id="address"
                            name="address"
                            value={state.address}
                            label={ t('swms.address') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                    <TableCell style={{ width : "30%", padding: "0px" }}>
                        <TextField
                            id="title"
                            name="abn"
                            value={state.abn}
                            label={ t('swms.abn') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ width : "30%", padding: "0px" }}>
                        <TextField
                            id="companyContact"
                            name="companyContact"
                            value={state.companyContact}
                            label={ t('swms.companyContact') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                    <TableCell style={{ width : "30%", padding: "0px" }}>
                        <TextField
                            id="position"
                            name="position"
                            value={state.position}
                            label={ t('swms.position') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                    <TableCell style={{ width : "30%", padding: "0px" }}>
                        <TextField
                            id="phoneNumber"
                            name="phoneNumber"
                            value={state.phoneNumber}
                            label={ t('swms.phoneNumber') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                </TableRow>
            </Table>
            <Grid item xs={12} style={{ backgroundColor: 'lightblue'}}>
                <Typography component="h4" variant="h6" style={{ padding: "10px", paddingLeft: "20px" }}>
                    { t('swms.projectDetails') }
                </Typography>
            </Grid>
            <Table>
                <TableRow>
                    <TableCell style={{ width : "70%", padding: "0px" }}>
                        <TextField
                            id="project"
                            name="project"
                            value={state.project}
                            label={ t('swms.project') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                    <TableCell style={{ width : "30%", padding: "0px", textAlign: "center" }} rowSpan={3}>
                        {/* image canvas intentionally disabled in current layout */}
                        {
                            !state.uploadedFileId
                            ? <span><label>{ t('swms.photo') }</label><input type="file" id="imageLoader" name="imageLoader" onChange={this.onImageUpload}/></span>
                            : <span style={{ textAlign: 'center' }}>
                                <label><b>{state.uploadedFileName}</b></label><br/>
                                <GreyButton style={{ marginRight: '20px', marginTop: '20px', marginLeft: '20px' }} onClick={() => ApiUtils.downloadFile(state.uploadedFileId)}>{ t('common.download') }</GreyButton>
                                <RedButton style={{ marginRight: '20px', marginTop: '20px' }} onClick={this.onFileRemove}>{ t('common.remove') }</RedButton>
                            </span>
                        }
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ width : "70%", padding: "0px" }}>
                        <TextField
                            id="jobAddress"
                            name="jobAddress"
                            value={state.jobAddress}
                            label={ t('swms.jobAddress') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ width : "70%", padding: "0px" }}>
                        <TextField
                            id="jobDescription"
                            name="jobDescription"
                            value={state.jobDescription}
                            label={ t('swms.jobDescription') }
                            onChange={this.onChange}
                            variant="outlined"
                            style={{ width: '100%' }}
                        />
                    </TableCell>
                </TableRow>
            </Table>
            <Grid item xs={12} style={{ backgroundColor: 'lightblue'}}>
                <Typography component="h7" variant="subtitle1" style={{ padding: "10px", paddingLeft: "20px" }}>
                    { t('swms.approvedBy') }
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Paper square>
                    <TextField
                        id="printName"
                        name="printName"
                        value={state.printName}
                        label={ t('swms.printName') }
                        onChange={this.onChange}
                        variant="outlined"
                        style={{ width: '100%' }}
                    />
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                        { t('swms.signatureHelper') }
                        <SignaturePad
                            canvasProps={{ width: "250px", height: "150px" }}
                            onEnd={() => this.onSignatureDrawn('signature', this.sigPad)}
                            ref={(ref) => {
                                this.sigPad = ref;
                                if (state.signature && this.sigPad) {
                                    this.sigPad.fromDataURL(state.signature, { width: 250, height: 150})
                                }
                            }}
                        />
                        <GreyButton onClick={() => this.sigPad.clear()}>
                            { t('common.clear') }
                        </GreyButton>
                    </div>
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper square>
                    <KeyboardDatePicker
                         disableToolbar
                         autoOk
                         variant="outlined"
                         format="DD/MM/YYYY"
                         id="date"
                         label={ t('common.date') }
                         name="date"
                         value={state.date}
                         onChange={(event) => this.onDateChange(event, 'date')}
                         KeyboardButtonProps={{
                             'aria-label': 'change date',
                         }}
                         style={{ width: "100%", marginTop: "8px", paddingLeft: "8px"}}
                     />
                </Paper>
            </Grid>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.zoomedInModalShow}
                onClose={this.onModalClose}
            >
                <PhotoModal file={state.uploadedPhoto}/>
            </Modal>
        </Grid>;
    }
}

SwmsPartOne.propTypes = {
    onChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(classes)(SwmsPartOne);
